<template>
  <div>
    <el-dropdown-item type="text" @click.native="handleRequestDownload">
      Скачать реестр
    </el-dropdown-item>
    <!--//deprecated-->
    <!--    <el-dialog-->
    <!--      title="Выбор типа реестра для скачивания"-->
    <!--      :visible.sync="visible"-->
    <!--      :width="isMobile ? '90%' : '900px'"-->
    <!--      custom-class="choose-registry-dialog"-->
    <!--      append-to-body-->
    <!--    >-->
    <!--      <loader-wrapper :loading="loading">-->
    <!--        <el-radio-group v-model="type" class="df fd-column">-->
    <!--          <el-row type="flex" align="middle" class="fw-wrap gap-30">-->
    <!--            <el-radio-->
    <!--              v-for="reg in Object.values(registryOptions)"-->
    <!--              :key="reg.text"-->
    <!--              :label="reg.text"-->
    <!--              class="mb-10"-->
    <!--            >-->
    <!--              <div class="df fd-column">-->
    <!--                <span class="title">{{ reg.name }}</span>-->
    <!--                <el-image-->
    <!--                  style="width: 100px; height: 100px"-->
    <!--                  :src="reg.file"-->
    <!--                  :preview-src-list="[reg.file]"-->
    <!--                >-->
    <!--                  <div slot="placeholder" class="image-slot">-->
    <!--                    <loader-wrapper-->
    <!--                      loading-->
    <!--                      spinner="el-icon-loading"-->
    <!--                      text="Загрузка..."-->
    <!--                    />-->
    <!--                  </div>-->
    <!--                </el-image>-->
    <!--              </div>-->
    <!--            </el-radio>-->
    <!--          </el-row>-->
    <!--        </el-radio-group>-->
    <!--        <el-row class="ta-r">-->
    <!--          <el-button-->
    <!--            :loading="loading"-->
    <!--            type="primary"-->
    <!--            @click="formationRegistry"-->
    <!--          >-->
    <!--            Скачать-->
    <!--          </el-button>-->
    <!--        </el-row>-->
    <!--      </loader-wrapper>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { registryOptions } from './constants'

const DocAPI = RepositoryFactory.get('document')
const registryBidRepository = RepositoryFactory.get('registryBidRepository')

export default {
  name: 'ChooseRegistryType',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    inn: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      registryOptions,
      visible: false,
      loading: false,
      type: 'registry_ast',
    }
  },
  methods: {
    handleRequestDownload() {
      registryBidRepository
        .checkRegistryFields({ day_id: this.id })
        .then(() => {
          this.downloadRegistryBlanc({ day_id: this.id, by_mail: 0 })
          this.visible = false
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    formationRegistry() {
      this.loading = true

      DocAPI.getRegistry(this.id, this.inn, this.type)
        .then(response => {
          this.forceFileDownload(
            response,
            `${this.registryOptions[this.type].fileName}_${this.date}.xlsx`,
          )
          this.visible = false
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="sass">
.choose-registry-dialog
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .el-radio
    display: flex
    width: 150px
    margin-right: 0
  .gap-30
    gap: 30px
  .title
    font-size: 16px
    font-weight: bold
    color: #000
    white-space: normal
    word-break: normal
    min-height: 32px
  .image-slot
    position: relative
    top: 50%
</style>
